import { render } from "./ReliefEntry.vue?vue&type=template&id=facbc3bc&scoped=true"
import script from "./ReliefEntry.vue?vue&type=script&lang=js"
export * from "./ReliefEntry.vue?vue&type=script&lang=js"

import "./ReliefEntry.vue?vue&type=style&index=0&id=facbc3bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-facbc3bc"]])

export default __exports__